import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectorRef, OnDestroy, Output, EventEmitter } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { DataService } from 'src/app/shared/service/data.service';
import { CurrencyService } from '../../../../shared/service/currency.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-line-stacked-bar-chart',
  templateUrl: './stacked-bar-chart.component.html',
  styleUrls: ['./stacked-bar-chart.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: '0' }),
        animate('1s ease-in-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [])
    ]),
    trigger('fillUp', [
      transition(':enter', [
        style({ height: '0' }),
        animate('1s ease-in-out', style({ height: '*' })),
      ]),
      transition(':leave', [])
    ])
  ]
})
export class StackedBarChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() graphData: any;
  /* istanbul ignore  next*/
  showNoData: any = false;
  showInGraph: any;
  /* istanbul ignore  next*/
  showTotalForBar: any = false;
  filterSelection: any;
  plotData: any;
  yScaleMax: number;
  yRange: any;
  symbolCode: any;
  hoveredItem: any;
  /* istanbul ignore  next*/
  colorArray = [{
    background: '#00abe6',
    color: '#fff'
  }, {
    background: '#ffc000',
    color: '#333B40'
  }];

  subscription: Subscription;
  currencyValue: any;
  /* istanbul ignore  next*/
  currencyData: any = {
    conversionFactor: '',
    yUnit: '',
    symbolCode: '',
    label: ''
  };

  // unitArr = [
  //   { key: 'kg', value: 'KG' },
  //   { key: 'ton', value: 'Tons' },
  //   { key: 'litre', value: 'L' },
  //   { key: 'pk', value: 'Pieces' },
  //   { key: 'm', value: 'M' },
  //   { key: 'st', value: 'ST' },
  //   { key: 'ea', value: 'EA' },
  // ];
  /* istanbul ignore  next*/
  unitArr = [
    { key: 'kg', value: 'KG' },
    { key: 'ton', value: 'Tons' },
    { key: 'litre', value: 'L' },
    // { key: 'pk', value: 'Pieces' },
    { key: 'pk', value: 'PC' },
    { key: 'm', value: 'M' },
    { key: 'st', value: 'ST' },
    { key: 'ea', value: 'EA' },
    { key: 'g', value: 'G' },
    { key: 'ml', value: 'ML' },
    { key: 'm2', value: 'M2' },
    { key: 'PCO', value: 'PCO' },
    { key: 'ROL', value: 'ROL' },
    { key: 'PWD', value: 'PWD' },
    { key: 'OZA', value: 'OZA' },
    { key: 'M3', value: 'M3' },
    { key: 'LB', value: 'LB' },
    { key: 'CS', value: 'CS' },
    { key: 'TO', value: 'TO' },
    { key: 'TC', value: 'TC' },
    { key: 'MM', value: 'MM' },
    { key: 'KM', value: 'KM' },
    { key: 'ZKE', value: 'ZKE' },
    { key: 'GLL', value: 'GLL' },
    { key: 'FT', value: 'FT' },
    { key: 'TH', value: 'TH' },
    { key: 'DZ', value: 'DZ' },
    { key: 'CJ', value: 'CJ' },
    { key: 'CM', value: 'CM' }
  ];

  unitTotalArr: any;
  quantityWasteArr: any;
  currentPopOverValue: any;
  popOverArr: any;
  /* istanbul ignore  next*/
  showPM = true;
  /* istanbul ignore  next*/
  showRM = true;
  /* istanbul ignore  next*/
  constructor(
    /* istanbul ignore  next*/
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private currencyService: CurrencyService,
  ) {
  }
  /* istanbul ignore  next*/
  ngOnChanges(changes: any): void {
    /* istanbul ignore  next*/
    if (changes.graphData && changes.graphData.currentValue) {
      /* istanbul ignore  next*/
      if (changes.graphData.currentValue.quantity && changes.graphData.currentValue.quantity.length) {
        /* istanbul ignore  next*/
        this.filterPlotData();
      } else {
        /* istanbul ignore  next*/
        this.plotData = [];
        this.showNoData = true;
      }
    }
  }
  /* istanbul ignore  next*/
  ngOnInit() {
    /* istanbul ignore  next*/
    this.dataService.on('lineDBWasteChange', this.filterChanged);
  }
  /* istanbul ignore  next*/
  filterChanged = (filterSelection: any) => {
    /* istanbul ignore  next*/
    this.showInGraph = filterSelection;
    this.filterPlotData();
  }
  /* istanbul ignore  next*/
  setScale(arr): void {
    /* istanbul ignore  next*/
    this.yScaleMax = -9999999999;
    let componentMaxVal = -9999999999;
    // arr.forEach(quantityArr => {
    arr.quantity.forEach(item => {
      /* istanbul ignore  next*/
      let componentTotal = 0;
      item.value.forEach(component => {
        /* istanbul ignore  next*/
        if (component && component.value) {
          /* istanbul ignore  next*/
          componentTotal += component.value;
          if (componentMaxVal < component.value) {
            /* istanbul ignore  next*/
            componentMaxVal = component.value;
          }
        }
      });
      /* istanbul ignore  next*/
      item.componentTotal = componentTotal;
      if (this.showTotalForBar) {
        /* istanbul ignore  next*/
        if (this.yScaleMax < item.total) {
          /* istanbul ignore  next*/
          this.yScaleMax = item.total;
        }
      } else {
        /* istanbul ignore  next*/
        if (this.yScaleMax < componentTotal) {
          /* istanbul ignore  next*/
          this.yScaleMax = componentTotal;
        }
      }
    });

    if (arr.quantity.length > 0) {
      /* istanbul ignore  next*/
      this.showNoData = false;
    } else {
      /* istanbul ignore  next*/
      this.showNoData = true;
    }

    // arr.quantity.forEach(quantityArr => {
    //   if (quantityArr.value.length > 0) {
    //     this.showNoData = false;
    //   } else {
    //     this.showNoData = true;
    //   }
    // });
  }

  /* istanbul ignore  next*/
  setTotal(arr) {
    arr.quantity.forEach(quantityArr => {
      /* istanbul ignore  next*/
      // item.quantity.forEach(quantityArr => {
      let componentTotal = 0;

      quantityArr.value.forEach(component => {
        /* istanbul ignore  next*/
        if (component && component.value) {
          componentTotal += component.value;
        }
      });
      /* istanbul ignore  next*/
      quantityArr.total = componentTotal;
      // });
    });
  }
  /* istanbul ignore  next*/
  filterPlotData() {
    // this.graphData = this.dataService.convertStandardizedUnit(this.graphData);
    /* istanbul ignore  next*/
    this.convertStandardizedUnitKey(this.graphData);
    /* istanbul ignore  next*/
    this.setTotal(this.graphData);
    /* istanbul ignore  next*/

    this.showTotalForBar = false;
    /* istanbul ignore  next*/
    const showingValues: any[] = [];
    /* istanbul ignore  next*/
    const dataToSort = JSON.parse(JSON.stringify(this.graphData));

    if (this.showInGraph) {
      /* istanbul ignore  next*/
      if (!this.showInGraph.total) {
        /* istanbul ignore  next*/
        this.showTotalForBar = false;
      }
      /* istanbul ignore  next*/
      this.showRM = false;
      /* istanbul ignore  next*/
      this.showPM = false;
      /* istanbul ignore  next*/
      for (const property in this.showInGraph) {
        /* istanbul ignore  next*/
        if (this.showInGraph[property] && property !== 'total') {
          /* istanbul ignore  next*/
          if (property === 'PM') {
            /* istanbul ignore  next*/
            this.showPM = true;
          } else if (property === 'RM') {
            /* istanbul ignore  next*/
            this.showRM = true;
          }
          /* istanbul ignore  next*/
          showingValues.push(property);
        }
      }
      /* istanbul ignore  next*/
      if (showingValues.length) {
        /* istanbul ignore  next*/
        dataToSort.quantity = dataToSort.quantity.filter((ele) => {
          /* istanbul ignore  next*/
          return (showingValues.indexOf(ele.type) !== -1);
        });
      }
    }
    /* istanbul ignore  next*/
    this.plotData = dataToSort;
    /* istanbul ignore  next*/
    this.setScale(this.plotData);
    /* istanbul ignore  next*/
    this.setUnitTotal(this.plotData);
    /* istanbul ignore  next*/
    this.setPopOverArr(this.plotData);
  }
  /* istanbul ignore  next*/
  ngOnDestroy(): void {
    /* istanbul ignore  next*/
    this.dataService.removeAllListnersFor('stackBarFilterChange');
    this.dataService.removeAllListnersFor('stackBarSFGChange');
  }
  /* istanbul ignore  next*/
  convertStandardizedUnitKey(arr) {
    /* istanbul ignore  next*/
    arr.quantity.forEach(quantityArr => {
      /* istanbul ignore  next*/
      quantityArr.value.forEach(component => {
        /* istanbul ignore  next*/
        this.unitArr.forEach(standardUnit => {
          /* istanbul ignore  next*/
          if (standardUnit.value === component.unit) {
            /* istanbul ignore  next*/
            component.unit = standardUnit.key;
          }
        });
      });
    });
  }
  /* istanbul ignore  next*/
  setUnitTotal(arr) {
    /* istanbul ignore  next*/
    this.unitTotalArr = {};

    const currentUnitTotal = {
      kg: 0,
      litre: 0,
      ton: 0,
      pk: 0,
      ea: 0,
      st: 0,
      m: 0,
      ml: 0,
      g: 0,
      m2: 0,
      MM: 0,
      M3: 0,
      LB: 0,
      DZ: 0,
      CJ: 0,
      CM: 0,
      KM: 0,
      ZKE: 0,
      GLL: 0,
      FT: 0,
      ROL: 0,
      PWD: 0,
      OZA: 0,
      TH: 0,
      CS: 0,
      TO: 0,
      TC: 0,
      PCO: 0,
    };
    /* istanbul ignore  next*/
    arr.quantity.forEach(quantityArr => {
      /* istanbul ignore  next*/
      quantityArr.value.forEach(component => {
        /* istanbul ignore  next*/
        switch (component.unit) {
          case 'ton': {
            /* istanbul ignore  next*/
            currentUnitTotal.ton = currentUnitTotal.ton + component.value;
            break;
          }
          case 'litre': {
            /* istanbul ignore  next*/
            currentUnitTotal.litre = currentUnitTotal.litre + component.value;
            break;
          }
          case 'pk': {
            /* istanbul ignore  next*/
            currentUnitTotal.pk = currentUnitTotal.pk + component.value;
            break;
          }
          case 'kg': {
            /* istanbul ignore  next*/
            currentUnitTotal.kg = currentUnitTotal.kg + component.value;
            break;
          }
          case 'ea': {
            /* istanbul ignore  next*/
            currentUnitTotal.ea = currentUnitTotal.ea + component.value;
            break;
          }
          case 'st': {
            /* istanbul ignore  next*/
            currentUnitTotal.st = currentUnitTotal.st + component.value;
            break;
          }
          case 'm': {
            /* istanbul ignore  next*/
            currentUnitTotal.m = currentUnitTotal.m + component.value;
            break;
          }
          case 'ml': {
            /* istanbul ignore  next*/
            currentUnitTotal.ml = currentUnitTotal.ml + component.value;
            break;
          }
          case 'g': {
            /* istanbul ignore  next*/
            currentUnitTotal.g = currentUnitTotal.g + component.value;
            break;
          }
          case 'm2': {
            /* istanbul ignore  next*/
            currentUnitTotal.m2 = currentUnitTotal.m2 + component.value;
            break;
          }
          case 'GLL': {
            /* istanbul ignore  next*/
            currentUnitTotal.GLL = currentUnitTotal.GLL + component.value;
            break;
          }
          case 'FT': {
            /* istanbul ignore  next*/
            currentUnitTotal.FT = currentUnitTotal.FT + component.value;
            break;
          }
          case 'TO': {
            /* istanbul ignore  next*/
            currentUnitTotal.TO = currentUnitTotal.TO + component.value;
            break;
          }
          case 'TH': {
            /* istanbul ignore  next*/
            currentUnitTotal.TH = currentUnitTotal.TH + component.value;
            break;
          }
          case 'ZKE': {
            /* istanbul ignore  next*/
            currentUnitTotal.ZKE = currentUnitTotal.ZKE + component.value;
            break;
          }
          case 'CS': {
            /* istanbul ignore  next*/
            currentUnitTotal.CS = currentUnitTotal.CS + component.value;
            break;
          }
          case 'TC': {
            /* istanbul ignore  next*/
            currentUnitTotal.TC = currentUnitTotal.TC + component.value;
            break;
          }
          case 'OZA': {
            /* istanbul ignore  next*/
            currentUnitTotal.OZA = currentUnitTotal.OZA + component.value;
            break;
          }
          case 'PCO': {
            /* istanbul ignore  next*/
            currentUnitTotal.PCO = currentUnitTotal.PCO + component.value;
            break;
          }
          case 'ROL': {
            /* istanbul ignore  next*/
            currentUnitTotal.ROL = currentUnitTotal.ROL + component.value;
            break;
          }
          case 'PWD': {
            /* istanbul ignore  next*/
            currentUnitTotal.PWD = currentUnitTotal.PWD + component.value;
            break;
          }
          case 'MM': {
            /* istanbul ignore  next*/
            currentUnitTotal.MM = currentUnitTotal.MM + component.value;
            break;
          }
          case 'DZ': {
            /* istanbul ignore  next*/
            currentUnitTotal.DZ = currentUnitTotal.DZ + component.value;
            break;
          }
          case 'M3': {
            /* istanbul ignore  next*/
            currentUnitTotal.M3 = currentUnitTotal.M3 + component.value;
            break;
          }
          case 'LB': {
            /* istanbul ignore  next*/
            currentUnitTotal.LB = currentUnitTotal.LB + component.value;
            break;
          }
          case 'CJ': {
            /* istanbul ignore  next*/
            currentUnitTotal.CJ = currentUnitTotal.CJ + component.value;
            break;
          }
          case 'CM': {
            /* istanbul ignore  next*/
            currentUnitTotal.CM = currentUnitTotal.CM + component.value;
            break;
          }
        }

      });
    });
    /* istanbul ignore  next*/
    this.unitTotalArr = currentUnitTotal;
  }
  /* istanbul ignore  next*/
  setPopOverArr(arr) {
    /* istanbul ignore  next*/
    this.quantityWasteArr = [];
    /* istanbul ignore  next*/
    this.currentPopOverValue = {
      totalValue: '',
      rmValue: 0,
      pmValue: 0,
      unit: '',
      unitValue: ''
    };

    let unitFound = false;
    this.popOverArr = {};
    /* istanbul ignore  next*/
    // arr.forEach((items, itemIndex) => {
    this.popOverArr = {
      id: arr.id,
      // type: arr.type,
      name: arr.name,
      quantityWaste: []
    };

    this.quantityWasteArr = [];
    /* istanbul ignore  next*/
    arr.quantity.forEach(quantityArrs => {
      /* istanbul ignore  next*/
      quantityArrs.value.forEach(components => {
        /* istanbul ignore  next*/
        this.currentPopOverValue = {
          rmValue: 0,
          pmValue: 0,
          totalValue: '',
          unit: '',
          unitValue: ''
        };
        /* istanbul ignore  next*/
        this.currentPopOverValue.unit = components.unit;
        /* istanbul ignore  next*/
        this.unitArr.forEach(standardUnit => {
          /* istanbul ignore  next*/
          if (standardUnit.key === components.unit) {
            /* istanbul ignore  next*/
            this.currentPopOverValue.unitValue = standardUnit.value;
          }
        });
        /* istanbul ignore  next*/
        if (quantityArrs.type === 'RM') {
          /* istanbul ignore  next*/
          this.currentPopOverValue.rmValue = components.value;
        } else if (quantityArrs.type === 'PM') {
          /* istanbul ignore  next*/
          this.currentPopOverValue.pmValue = components.value;
        }

        switch (components.unit) {
          case 'kg': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.kg;
            break;
          }
          case 'ton': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.ton;
            break;
          }
          case 'litre': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.litre;
            break;
          }
          case 'ea': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.ea;
            break;
          }
          case 'pk': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.pk;
            break;
          }
          case 'm': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.m;
            break;
          }
          case 'st': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.st;
            break;
          }
          case 'g': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.g;
            break;
          }
          case 'ml': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.ml;
            break;
          }
          case 'm2': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.m2;
            break;
          }
          case 'KM': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.KM;
            break;
          }
          case 'ZKE': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.ZKE;
            break;
          }
          case 'GLL': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.GLL;
            break;
          }
          case 'FT': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.FT;
            break;
          }
          case 'TH': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.TH;
            break;
          }
          case 'CS': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.CS;
            break;
          }
          case 'TO': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.TO;
            break;
          }
          case 'TC': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.TC;
            break;
          }
          case 'PCO': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.PCO;
            break;
          }
          case 'ROL': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.ROL;
            break;
          }
          case 'LB': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.LB;
            break;
          }
          case 'PWD': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.PWD;
            break;
          }
          case 'MM': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.MM;
            break;
          }
          case 'M3': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.M3;
            break;
          }
          case 'OZA': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.OZA;
            break;
          }
          case 'CJ': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.CJ;
            break;
          }
          case 'CM': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.CM;
            break;
          }
          case 'DZ': {
            /* istanbul ignore  next*/
            this.currentPopOverValue.totalValue = this.unitTotalArr.DZ;
            break;
          }
        }

        unitFound = false;
        /* istanbul ignore  next*/
        this.quantityWasteArr.forEach((quantityWaste, quantityWasteIndex) => {
          /* istanbul ignore  next*/
          if (quantityWaste.unit === this.currentPopOverValue.unit) {
            /* istanbul ignore  next*/
            unitFound = true;

            if (quantityArrs.type === 'RM') {
              /* istanbul ignore  next*/
              quantityWaste.rmValue = this.currentPopOverValue.rmValue;
            } else if (quantityArrs.type === 'PM') {
              /* istanbul ignore  next*/
              quantityWaste.pmValue = this.currentPopOverValue.pmValue;
            }
          }
        });

        if (!unitFound) {
          /* istanbul ignore  next*/
          this.quantityWasteArr.push(this.currentPopOverValue);
        }
      });
    });
    /* istanbul ignore  next*/
    this.popOverArr.quantityWaste = this.quantityWasteArr;
    // });
  }
}

